import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { buildLink } from "common/routing";
import { useIsScreenSize } from "../../hooks/useWindowSize";
import { track } from "../../utils/tracking";
import { AuthContext } from "../Authorization/AuthContext";
import { ButtonLink } from "../Common/ButtonLink";
import { accountTitle } from "./utils";

export const HomeButton = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const isMobile = useIsScreenSize("mobile");
  const account = useContext(AuthContext).account!;

  return (
    <ButtonLink
      leftIconName="chevron-left"
      styleVariant="primary"
      size="small"
      onClick={() => {
        track("Homepage link clicked");
        history.push(buildLink("guestHome", { accountId: account.id }));
      }}
      style={{ padding: 0 }}
    >
      {isMobile
        ? t("common-homepage")
        : t("button-go-to-homepage", { accountName: accountTitle() })}
    </ButtonLink>
  );
};
